import React from 'react';
import PropTypes from 'prop-types';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import settings from './settings';

/**
 * A free preview progress bar.
 */
const FreePreview = ({
  onConnectClick,
  percent,
  timestamp,
}) => (
  <div className="adobe-primetime-preview">
    <div
      className="adobe-primetime-preview__time"
    >
      <div
        className="adobe-primetime-preview__time__progress"
      >
        <CircularProgressbar
          value={100 - (percent * 100)}
          strokeWidth={50}
          styles={buildStyles({
            strokeLinecap: 'butt',
          })}
        />
      </div>
      <time>
        {timestamp}
      </time>
    </div>
    <div className="adobe-primetime-preview__details">
      <h3>
        {settings('strings.free_preview.header')}
      </h3>
      <p>
        {settings('strings.free_preview.description')}
      </p>
    </div>
    <button
      type="button"
      className="adobe-primetime-preview__button"
      onClick={onConnectClick}
    >
      <span className="adobe-primetime-preview__button__text--desktop">
        {settings('strings.lock_screen.connect_button')}
      </span>
      <span className="adobe-primetime-preview__button__text--mobile">
        {settings('strings.free_preview.connect_button_mobile')}
      </span>
    </button>
  </div>
);

FreePreview.propTypes = {
  onConnectClick: PropTypes.func,
  percent: PropTypes.number,
  timestamp: PropTypes.string,
};

FreePreview.defaultProps = {
  onConnectClick: () => {},
  percent: 0,
  timestamp: '0:00',
};

export default FreePreview;
